import axios from 'axios';
import config from '../config/config';

class ProjectStatsApi {
    static getProjectStats() {
        return axios.get(`${config.server.endpoint}backend/projectStats`);
    }
}

export default ProjectStatsApi;
